module.exports = __webpack_public_path__ + "img/gallery12.2ead4e4c.jpg";